import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { delay } from "@Shared/@Utils/utils";
import { trim } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ButtonLoader",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: true
    },
    showCustomColor: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      animating: false,
      showLoader: true,
      showIcon: false,
      animateButtonClassNames: {
        "animation-started": null,
        "animation-finished": null
      },
      animateContentClassNames: {
        "animation-content-error": null
      },
      animateButtonStyles: {
        "--animate-color": null,
        "--animate-bg-color": null
      },
      originalContentStyles: {
        width: null,
        height: null
      }
    };
  },
  computed: {
    iconStatus() {
      return !this.status ? "times" : "check";
    },
    customColor() {
      const bodyStyles = window.getComputedStyle(document.body);
      return trim(bodyStyles.getPropertyValue(`--${this.color}`));
    }
  },
  watch: {
    loading(startAnimation) {
      if (startAnimation) this.startAnimation();else this.endAnimation();
    }
  },
  methods: {
    getOriginalContentNode() {
      const originalContent = this.$refs.originalContent.firstElementChild;
      // we want to make sure to get the bootstrap .btn element, he's the one
      // with the color and attributes set
      if (!originalContent.classList.contains("btn")) {
        return originalContent.querySelector(".btn");
      }
      return originalContent;
    },
    getOriginalContentStyles() {
      const originalContentElement = this.getOriginalContentNode();
      const computedStyles = window.getComputedStyle(originalContentElement);
      const {
        backgroundColor,
        color,
        width,
        height
      } = computedStyles;
      return {
        backgroundColor,
        color,
        width,
        height
      };
    },
    setContextColors() {
      let {
        backgroundColor,
        color
      } = this.getOriginalContentStyles();
      const rgbWhite = ["rgb(0, 0, 0)", "rgba(0, 0, 0, 0)"];
      const hasWhiteBackground = _includesInstanceProperty(rgbWhite).call(rgbWhite, backgroundColor);
      this.animateButtonStyles["--animate-color"] = this.showCustomColor ? rgbWhite[0] : hasWhiteBackground ? backgroundColor : color;
      this.animateButtonStyles["--animate-bg-color"] = this.showCustomColor ? this.customColor : hasWhiteBackground ? color : backgroundColor;
    },
    setContextSize() {
      const {
        width,
        height
      } = this.getOriginalContentStyles();
      this.originalContentStyles.width = width;
      this.originalContentStyles.height = height;
    },
    async startAnimation() {
      this.setContextColors();
      this.setContextSize();
      this.animating = true;
      await this.$nextTick();
      this.animateButtonClassNames["animation-started"] = true;
    },
    async endAnimation() {
      //let the start animation roll a bit if end animation is called too fast
      await delay(600);

      // make the button grow from the loading animation
      this.animateButtonClassNames["animation-finished"] = true;

      //check if should show failure styles (X icon, red button)
      await this.$nextTick();
      if (!this.status) {
        this.animateContentClassNames["animation-content-error"] = true;
      }

      //start animating the button to its original state
      await delay(600);
      this.animateButtonClassNames["animation-started"] = null;

      //for the final cycle, show the result icon and hide the spinner
      this.showIcon = true;
      this.showLoader = false;
      await this.$nextTick();

      //let the results show for a bit and restart
      await delay(600);
      this.animating = false;
      this.resetLoader();
      this.$emit("finish");
    },
    resetLoader() {
      this.animating = false;
      this.showLoader = true;
      this.showIcon = false;
      this.animateButtonStyles = {
        "--animate-color": null,
        "--animate-bg-color": null
      };
      this.animateButtonClassNames = {
        "animation-started": null,
        "animation-finished": null
      };
      this.animateContentClassNames = {
        "animation-content-error": null
      };
      this.originalContentStyles = {
        width: null,
        height: null
      };
    }
  }
});